/* Odds Comfort: core. Config, helpers, money, plurals, overlays, toast, lazy catalog. Everything else hangs off window.Odds. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('odds-config');
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = { strings: {}, plurals: {}, routes: {}, features: {} }; }

  var Odds = (window.Odds = { cfg: cfg });
  var bus = {};
  Odds.on = function (e, fn) { (bus[e] = bus[e] || []).push(fn); };
  Odds.off = function (e, fn) { bus[e] = (bus[e] || []).filter(function (f) { return f !== fn; }); };
  Odds.emit = function (e, d) { (bus[e] || []).slice().forEach(function (fn) { try { fn(d); } catch (err) { console.error(err); } }); };

  Odds.$ = function (s, r) { return (r || document).querySelector(s); };
  Odds.$$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  Odds.rtl = !!cfg.rtl;
  Odds.reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  Odds.debounce = function (fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; };
  Odds.esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  Odds.store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* storage unavailable */ } },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) { /* ignore */ } }
  };

  /* ---- strings and plurals ---- */
  Odds.t = function (key, vars) {
    var s = (cfg.strings && cfg.strings[key]) || key;
    if (vars) Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  };
  /* expected delivery dates on product pages and in the cart (the Egyptian weekend, Friday and Saturday, is skipped) */
  Odds.paintDelivery = function (scope) {
    var els = (scope || document).querySelectorAll('[data-delivery-date]');
    if (!els.length) return;
    var addDays = function (n) { var d = new Date(), c = 0; while (c < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 5 && w !== 6) c++; } return d; };
    var f;
    try { f = new Intl.DateTimeFormat(cfg.locale === 'ar' ? 'ar-EG-u-nu-latn' : 'en-GB', { day: 'numeric', month: 'short' }); } catch (e) { return; }
    Array.prototype.forEach.call(els, function (el) {
      var min = Number(el.getAttribute('data-min')) || 2, max = Number(el.getAttribute('data-max')) || 5;
      el.textContent = Odds.t('delivery_between', { dates: f.format(addDays(min)) + ' – ' + f.format(addDays(max)) });
    });
  };
  Odds.on('dom:updated', function () { Odds.paintDelivery(); });
  if (document.readyState !== 'loading') Odds.paintDelivery(); else document.addEventListener('DOMContentLoaded', function () { Odds.paintDelivery(); });

  var pr = null;
  try { pr = new Intl.PluralRules(cfg.locale || 'en'); } catch (e) { pr = null; }
  Odds.plural = function (key, n) {
    var forms = (cfg.plurals && cfg.plurals[key]) || {};
    var rule = pr ? pr.select(n) : (n === 1 ? 'one' : 'other');
    var s = forms[rule] || forms.other || String(n);
    return s.split('{n}').join(n);
  };

  /* ---- money ---- */
  function fmtNum(n, precision, thousands, decimal) {
    if (isNaN(n) || n == null) return '0';
    n = (n / 100).toFixed(precision);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[0] + (parts[1] ? decimal + parts[1] : '');
  }
  Odds.money = function (cents, noZero) {
    var f = (cfg.moneyFormat || '{{amount}}').replace(/<[^>]+>/g, '');
    var v = f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, name) {
      switch (name) {
        case 'amount': return noZero && cents % 100 === 0 ? fmtNum(cents, 0, ',', '.') : fmtNum(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return fmtNum(cents, 0, ' ', '.');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
        default: return fmtNum(cents, 2, ',', '.');
      }
    });
    return v;
  };
  Odds.moneyShort = function (cents) { return Odds.money(cents, true); };

  /* ---- fetch helpers ---- */
  Odds.fetchJSON = function (url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Request failed'); e.status = r.status; e.body = j; throw e; } return j; });
    });
  };
  Odds.url = function (path) { return (cfg.root || '/').replace(/\/$/, '') + path; };

  /* ---- overlays (drawers, modals, search, mobile menu) with focus trap ---- */
  var stack = [];
  var scrim = null;
  function focusables(el) { return Odds.$$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', el).filter(function (e) { return e.offsetParent !== null; }); }
  Odds.overlay = {
    open: function (el, opts) {
      if (!el) return;
      opts = opts || {};
      scrim = scrim || document.getElementById('scrim');
      var last = document.activeElement;
      if (stack.length && stack[stack.length - 1].el !== el && !opts.stack) this.closeAll(true);
      el.classList.add(el.classList.contains('search') ? 'open' : 'on');
      el.removeAttribute('inert');
      el.setAttribute('aria-hidden', 'false');
      if (!opts.noScrim && scrim) scrim.classList.add('on');
      document.body.classList.add('lock');
      stack.push({ el: el, last: last, noScrim: opts.noScrim });
      el.dispatchEvent(new CustomEvent('overlay:open', { bubbles: true }));
      setTimeout(function () {
        var f = opts.focus ? Odds.$(opts.focus, el) : focusables(el)[0];
        if (f) f.focus({ preventScroll: true });
      }, 60);
    },
    close: function (el, keepFocus) {
      if (!el) return;
      el.classList.remove('on', 'open');
      el.setAttribute('aria-hidden', 'true');
      var idx = -1;
      for (var i = 0; i < stack.length; i++) if (stack[i].el === el) idx = i;
      var rec = idx > -1 ? stack.splice(idx, 1)[0] : null;
      if (!stack.length) {
        if (scrim) scrim.classList.remove('on');
        document.body.classList.remove('lock');
      }
      el.dispatchEvent(new CustomEvent('overlay:close', { bubbles: true }));
      if (!keepFocus && rec && rec.last && rec.last.focus) { try { rec.last.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
    },
    closeAll: function (keepFocus) { stack.slice().reverse().forEach(function (r) { Odds.overlay.close(r.el, keepFocus); }); },
    top: function () { return stack.length ? stack[stack.length - 1].el : null; },
    isOpen: function (el) { return el.classList.contains('on') || el.classList.contains('open'); }
  };
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && stack.length) { Odds.overlay.close(stack[stack.length - 1].el); return; }
    if (e.key === 'Tab' && stack.length) {
      var el = stack[stack.length - 1].el, f = focusables(el);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'scrim' && stack.length) Odds.overlay.close(stack[stack.length - 1].el);
    var c = e.target.closest && e.target.closest('[data-overlay-close]');
    if (c) { var o = c.closest('.drawer,.modal,.search,.mmenu'); if (o) Odds.overlay.close(o); }
  });

  /* ---- toast ---- */
  var toastT = null, toastFn = null;
  Odds.toast = function (msg, actLabel, fn) {
    var t = document.getElementById('toast'); if (!t) return;
    document.getElementById('toastText').textContent = msg;
    var b = document.getElementById('toastAct');
    b.textContent = actLabel || ''; b.hidden = !actLabel; toastFn = fn || null;
    t.classList.add('on'); clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('on'); }, 3400);
  };
  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'toastAct') { document.getElementById('toast').classList.remove('on'); if (toastFn) toastFn(); }
  });

  /* ---- bump a counter badge ---- */
  Odds.bump = function (el, n) {
    if (!el) return;
    el.hidden = !n; el.textContent = n;
    el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    setTimeout(function () { el.classList.remove('bump'); }, 300);
  };

  /* ---- lazy catalog (every product, compact) ---- */
  var catPromise = null;
  var CAT_KEY = 'odds:catalog:' + (cfg.locale || 'en');
  Odds.catalog = {
    items: [],
    byHandle: {},
    ready: false,
    index: function (items) {
      Odds.catalog.items = items;
      Odds.catalog.byHandle = {};
      items.forEach(function (p, i) { p.rank = i; Odds.catalog.byHandle[p.h] = p; });
      Odds.catalog.ready = true;
    },
    load: function () {
      if (catPromise) return catPromise;
      var cached = Odds.store.get(CAT_KEY, null);
      if (cached && cached.items && Date.now() - cached.t < 15 * 60 * 1000 && cached.v === cfg.catalogVersion) {
        Odds.catalog.index(cached.items);
        catPromise = Promise.resolve(cached.items);
        return catPromise;
      }
      /* no "Accept: application/json" here: Shopify answers that with an empty body for a collection page */
      catPromise = fetch(Odds.url('/collections/all?view=catalog'), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('catalog ' + r.status); return r.text(); })
        .then(function (t) { if (!t || !t.trim()) throw new Error('catalog empty'); return JSON.parse(t); })
        .then(function (j) {
          var items = j.products || [];
          Odds.catalog.index(items);
          Odds.store.set(CAT_KEY, { t: Date.now(), v: cfg.catalogVersion, items: items });
          return items;
        })
        .catch(function (err) {
          console.warn('Odds catalog unavailable', err);
          if (cached && cached.items) { Odds.catalog.index(cached.items); return cached.items; }
          Odds.catalog.index([]);
          return [];
        });
      return catPromise;
    },
    /* try again after a failed load (the finder does this once) */
    reload: function () { catPromise = null; Odds.catalog.ready = false; return Odds.catalog.load(); }
  };

  /* ---- product image helper for catalog items: Shopify CDN width swap ---- */
  Odds.img = function (src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  };

  /* ---- family / cut display helpers ---- */
  Odds.cutLabel = function (c) { return Odds.t('cut_' + String(c || '').replace('-', '')) ; };
  Odds.deptLabel = function (d) { return Odds.t('dept_' + d); };

  document.documentElement.classList.add('odds-ready');
  Odds.emit('core:ready');
})();
